import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamReportsClient } from 'src/app/generated-client/generated-api-client';

@Component({
  selector: 'app-exam-report-students-tab',
  templateUrl: './exam-report-students-tab.component.html',
  styleUrls: ['./exam-report-students-tab.component.sass'],
})
export class ExamReportStudentsTabComponent implements OnInit {
  id: string = '';

  constructor(private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private _examReportClient: ExamReportsClient) {
      route.parent?.paramMap.subscribe(next => {
        this.id = next.get('id') ?? '';
      });
    }

  ngOnInit(): void {
    this._examReportClient.get(this.id).subscribe(examReport => {
      this.titleService.setTitle(examReport.identifier + ' - vizsgázói');
    });
  }
}
